import React from 'react'
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner'
import './index.scss'
import DownloadingSvg from '../../../Assets/Downloading.svg'

const LoadingGif = ({ label }) => (
  <div className="common-component-loading-container">
    <img
      className="downloading-background-image"
      src={DownloadingSvg}
      alt=""
    />
    <div className="gif-container">
      <Spinner
        size={SpinnerSize.small}
        label={label || 'Loading...'}
      />
    </div>
  </div>
)
export default LoadingGif
